import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=080f6cc8&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ben/Documents/GitHub/casa-padrino-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080f6cc8')) {
      api.createRecord('080f6cc8', component.options)
    } else {
      api.reload('080f6cc8', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=080f6cc8&", function () {
      api.rerender('080f6cc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/casa/Carousel.vue"
export default component.exports